import React from 'react'
import { FormValues } from 'donate/types'
import { HolderTitle } from './'
import { connect } from 'formik'

export const HolderHeadline = connect<{}, FormValues>(({ formik }) => {
  const companyDonation = formik.values._company_donation
  const headline = companyDonation ? <h4>{i18n.t('donate.donor_headline.company')}</h4> : <HolderTitle />
  const switchLabel = companyDonation
    ? i18n.t('donate.donor_headline.switch_to_personal')
    : i18n.t('donate.donor_headline.switch_to_company')
  return (
    <div className="flex justify-between items-baseline">
      <div className="donations-form-holder-label">{headline}</div>
      <button
        type="button"
        className="donation-form-company-toggle simulated-link font-regular small"
        onClick={() => {
          void formik.setFieldValue('_company_donation', !companyDonation)
          if (!formik.values.receipt_desired) void formik.setFieldValue('receipt_desired', true)
        }}
      >
        {switchLabel}
      </button>
    </div>
  )
})
